import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import am5themes_Responsive from "@amcharts/amcharts5/themes/Responsive";
import 'CssFolder/chart.scss';

export default function AttendanceScheduledVisitsDonutChartComponent() {

    let chart;
    let chartId = 'piechart-attendance-checkinout';
    let root;
    let series;
    let legend;
    let totalLabel;

    let onCheckInOutChartDataChanged = (_data) => {
        if (_data) {
            am5.array.each(am5.registry.rootElements, function (root) {
                if (root && root.dom.id == chartId) {
                    root.dispose();
                }
            });
            initChart(_data);
        }
    }

    function initChart(chartData) {
        createChart();
        createSeries();
        loadData(chartData);
        setTotalLabel(chartData);
        createLegend();
        // Animate on when appear
        series.appear(1000, 100);
    }
    
    function createChart() {
        root?.dispose(); // dispose any pre-existing roots
        root = am5.Root.new(chartId);

        // Formatter
        root.numberFormatter.set("numberFormat", "#,###.#");

        // Themes
        root.setThemes([
            am5themes_Responsive.new(root),
            am5themes_Animated.new(root)
        ]);

        // Chart settings
        chart = root.container.children.push(
            am5percent.PieChart.new(root, {
                radius: am5.percent(80),
                innerRadius: am5.percent(70),
                // layout: root.horizontalLayout,
                layout: root.verticalLayout,
            })
        );

    }

    function createSeries() {
        series = chart.series.push(am5percent.PieSeries.new(root, {
            alignLabels: true,
            valueField: "count",
            categoryField: "attendancetypeName",
            legendLabelText: "{category}",
            legendValueText: "[fontSize: 12px;bold]{valuePercentTotal.formatNumber('0.0')}%[/]",
            tooltip: am5.Tooltip.new(root, {
                labelText: "{attendancetypeName}: {count}"
            })
        }));

        series.get("colors").set("colors", [
            am5.color(0x84E0BE),
            am5.color(0xFFBC6E),
            am5.color(0xF38068)
        ]);

        series.labels.template.setAll({
            fontSize: 10,
            text: "{attendancetypeName}:\n[bold]{valuePercentTotal.formatNumber('0.0')}%[/] ({count})",
        });

        // Add label
        totalLabel = root.tooltipContainer.children.push(am5.Label.new(root, {
            x: am5.percent(50),
            y: am5.percent(47),
            centerX: am5.p50,
            centerY: am5.p50,
            fill: am5.color(0x000000),
            fontSize: 14,
            textAlign: "center"
        }));
    }

    function loadData(chartData) {
        series.data.setAll(chartData);
    }

    function setTotalLabel(chartData) {
        let total = 0;
        // Calculate total
        chartData.forEach(e => {
            total += e.count;
        });

        totalLabel.set("text", "Scheduled Visits\n[fontSize: 24px;bold]" + total + "[/]");
    }

    function createLegend() {
        legend = chart.children.push(am5.Legend.new(root, {
            centerX: am5.p50,
            x: am5.p50,
            layout: root.gridLayout,
        }));

        legend.labels.template.setAll({
            fontSize: 12,
            fontWeight: "300"
        });

        legend.data.setAll(series.dataItems);
    }

    return {
        oninit: function () {
        },
        oncreate: function (vnode) {
            if (vnode.attrs.events) {
                vnode.attrs.events.onCheckInOutChartDataChanged = onCheckInOutChartDataChanged;
            }
            if (vnode.attrs.data) {
                initChart(vnode.attrs.data);
            }
        },
        view: function (vnode) {
            return m('.chart', {
                id: chartId,
                style: 'min-width: 320px',
            });
        }
    }
}
